import { z } from 'zod';

// Empty string → null, else validate as non-empty string.
// Use for nullable text fields where FormTextField stores '' for empty.
export const nullableTextInput = z
  .string()
  .transform((v) => (v === '' ? null : v))
  .pipe(z.string().min(1).nullable());

// Empty string → null, else validate as IP address.
export const nullableIpInput = z
  .string()
  .transform((v) => (v === '' ? null : v))
  .pipe(z.string().ip('Invalid IP address').nullable());
